export default __webpack_public_path__ + "static/media/pictogramValuable40.ef763675.svg";